import { memo } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { useRemotionPlayerPause } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerPause';

function PlayPause() {
  const { isPlaying, pause, play } = useRemotionPlayerPause();
  return (
    <PlayerTimelineButton
      tooltipTitle={isPlaying ? 'Pause' : 'Play'}
      buttonId="play-pause-button"
      buttonClassName="bg-slate-100"
      onClick={() => {
        if (isPlaying) {
          pause();
        } else {
          play();
        }
      }}
      iconName={isPlaying ? 'IconPlayerPauseFilled' : 'IconPlayerPlayFilled'}
    />
  );
}
export default memo(PlayPause);
